import '../styles/SettingsMasthead.css';
import React from 'react';

function SettingsMasthead() {
  return (
    <section className="stm-root" aria-labelledby="settings-masthead-title">
      <div className="stm-rail" data-content-rail="workspace">
        <div className="stm-main">
          <p className="stm-kicker">
            <span className="stm-kicker__dot" aria-hidden="true" />
            Application configuration
          </p>
          <h1 id="settings-masthead-title" className="stm-heading">
            Settings
            <span className="stm-heading__mark" aria-hidden="true" />
          </h1>
          <p className="stm-subline">
            Application configuration persisted locally — run defaults, storage location and logging preferences.
            <span className="stm-subline__meta">LOCAL-FIRST · WINDOWS · NO CLOUD REQUIRED</span>
          </p>
        </div>
        <div className="stm-sticker-wrap">
          <span className="stm-sticker">
            <span className="stm-sticker__dot" aria-hidden="true" />
            Authorized target only
          </span>
        </div>
      </div>
    </section>
  );
}

export default SettingsMasthead;